// extracted by mini-css-extract-plugin
module.exports = {"required":"Required-module--required--27Gfq"};